import { AppBar as MuiAppBar, Box, Button, Typography } from '@mui/material';
import { Phone } from 'lucide-react';
import * as React from 'react';

const PHONE = { display: '1-888-969-7667', tel: '+18889697667' };

export function AppBar() {
  return (
    <MuiAppBar position="fixed" elevation={0} sx={{ top: 0, zIndex: 50, bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Box
        sx={{
          height: 57,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { xs: 3, md: 3 },
        }}
      >
        <Box
          component={'img'}
          src={'/assets/img/Logo.svg'}
          alt={'CoverRight'}
          sx={{ height: 24, objectFit: 'contain', flexShrink: 0 }}
        />

        <Button
          size={'small'}
          href={`tel:${PHONE.tel}`}
          sx={{
            gap: 1,
            px: 1.5,
            color: 'text.secondary',
            fontSize: '0.75rem',
            fontWeight: 600,
            height: 'auto',
            minHeight: 'unset',
            py: '6px',
            '&:hover': { color: 'text.primary', bgcolor: 'transparent' },
          }}
        >
          <Phone size={16} aria-hidden />
          <Typography component={'span'} sx={{ display: { xs: 'none', md: 'block' }, fontSize: 'inherit', fontWeight: 'inherit', whiteSpace: 'nowrap' }}>
            {PHONE.display}
          </Typography>
        </Button>
      </Box>
    </MuiAppBar>
  );
}
